import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSidebar } from "../actions/sidebar";
import { ISidebarItem } from "../components/Routes";
import { IReduxAppState } from "../reducers";


/**
 * Utility hook - pass through the tab and it 
 * will update the tab in redux
 *  */
export function useSideTabs(tab: ISidebarItem) {
    const position = useSelector((state: IReduxAppState) => state.sidebar.position.key);

    const dispatch = useDispatch();
    useEffect(() => {
        if (tab) {
            dispatch(setSidebar(tab));
        }
        // eslint-disable-next-line
    }, [tab]);
    return position;
}